// extracted by mini-css-extract-plugin
module.exports = {"ConsultantPages":"ConsultantPages_ConsultantPages__Bvww6"};